module.exports = __webpack_public_path__ + "img/daboul.4b5cb3ec.svg";